// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
// window.CKEDITOR_BASEPATH  = '//cdn.ckeditor.com/4.6.2/full-all/';
window.jQuery = $;
window.$ = $;
window.bootstrap = require("bootstrap");

import * as ActiveStorage from "@rails/activestorage";
import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import "channels";
import "../stylesheets/application.scss";
import "controllers";
import $ from "jquery"
import "bootstrap";
import 'select2';
import 'select2/dist/css/select2.css';
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'jquery-ui-bundle';

Rails.start();
ActiveStorage.start();

require('jquery');
require("packs/management_app/dashboard");
require("packs/management_app/organization_courses");
